<template>
  <div class="item_content">
    <div style="display: flex; align-items: center">
      <div class="pricture_name">
        {{ ProductItem.Name }}
      </div>
      <div
        class="item_price"
        :style="{ color: ProductItem.PriceColor }"
        style="
          width: 70px;
          color: red;
          font-size: 13pt;
          height: 10px;
          padding-left: 10px;
        "
      >
        {{ ProductItem.PriceFormat }}
      </div>
    </div>
    <div class="item_content_area" @click="LookProductDetail(ProductItem)">
      <van-image
        :style="{ height: imageHeigth + 'px' }"
        class="item_picture"
        fit="contain"
        :src="ProductItem.CompleteImages"
      />
      <div class="item_price_cart">
        <p
          class="description"
          v-if="ProductItem.Price > 0"
          style="color: red"
          v-html="ProductItem.Description"
        ></p>
        <p class="description" v-else v-html="ProductItem.Description"></p>
        <div class="item_price_cart_bottom"></div>
      </div>
    </div>

    <div class="item_bottom">
      <div style="font-size: 9pt">
        {{ tools.GetLanguageValue("public.app.已点") }}
        <span style="font-size: 11pt; color: red">
          {{ ProductItem.PlaceCount }}
        </span>
      </div>

      <div class="stepper_content">
        <van-icon
          name="cart"
          size="17pt"
          color="rgb(0, 157, 255)"
          v-if="ProductItem.Count == 0"
          @click="ProductItem.AddIsConfirm ? AddConfirm() : GetProduct()"
        />

        <van-stepper
          v-if="ProductItem.Count > 0"
          :disable-plus="DisablePlus"
          v-model="ProductItem.Count"
          :disable-input="true"
          :min="0"
          :before-change="beforeChange"
          @minus="MinusCartItem()"
          @plus="ProductItem.AddIsConfirm ? AddConfirm() : GetProduct()"
        />
      </div>
    </div>
    <div
      style="display: flex; gap: 5px"
      v-if="ProductItem.IngredientJson.length > 0"
    >
      <van-icon @click="IngredientTips" name="info" size="22" color="#F39801" />
      <van-tag
        style="margin: 3px"
        type="danger"
        v-for="(item, index) in ProductItem.IngredientJson"
        :key="index"
      >
        {{ item }}
      </van-tag>
    </div>
  </div>

  <van-action-sheet
    v-model:show="AttributeShow"
    :title="ProductItem.Name"
    style="overflow: auto"
    :style="{ height: clientHeight - 100 + 'px' }"
  >
    <div style="width: 100%; text-align: center">
      <van-swipe :autoplay="3000" lazy-render>
        <van-swipe-item v-for="(itemp, index) in Product.Pictures" :key="index">
          <img
            :src="itemp.CompleteImage"
            style="max-width: 80%; max-height: 300px"
          />
        </van-swipe-item>
        <!-- <van-swipe-item>
          <img :src="Product.Images" style="max-width: 80%; max-height: 300px" />
        </van-swipe-item> -->
      </van-swipe>
    </div>

    <div class="attribute_content">
      <van-col
        span="24"
        style="
          position: absolute;
          bottom: 5px;
          width: 100%;
          text-align: center;
          z-index: 1000000;
        "
      >
        <van-button
          @click="AddShoppingCart()"
          style="width: calc(100% - 50px)"
          color="rgb(0, 157, 255)"
        >
          {{ tools.GetLanguageValue("public.app.添加") }}
        </van-button>
      </van-col>

      
      <van-cell
        :title="tools.GetLanguageValue('public.app.要求')"
        v-if="
          Product.ProductRemarkFree.length > 0 ||
          Product.ProductRemarkCollectFree.length > 0
        "
      />

      <div style="font-size: 9pt">
        <p v-if="ProductItem.RemarkRequiredMinCount > 0">
          {{ tools.GetLanguageValue("public.app.最少需要选择") }}
          {{ ProductItem.RemarkRequiredMinCount }}
          {{ tools.GetLanguageValue("system.public.个") }}
        </p>

        <p v-if="ProductItem.RemarkRequiredMaxCount > 0">
          {{ tools.GetLanguageValue("public.app.最多可以选择") }}
          {{ ProductItem.RemarkRequiredMaxCount }}
          {{ tools.GetLanguageValue("system.public.个") }}
        </p>
      </div>

      <van-checkbox-group
     
        v-model="ProductRemarkOpts" 
        v-show="RemarkVisible"
        direction="horizontal"
      >
        <div
          v-for="productRemarkGroup in Product.ProductRemarkGroup"
          :key="productRemarkGroup"
          style="
            display: flex;
            justify-content: left;
            flex-wrap: wrap;
            width: 100%;
          "
        >
          <p style="min-width: 150px;width: 100%;">
            {{ productRemarkGroup.Name }}
          </p>
          <div
            v-for="item in productRemarkGroup.ProductRemarks"
            :key="item"
            style="
              margin: 5px;
              border-radius: 4px;
              border: 1px solid #ddd;
              padding: 5px;
            "
          >
            <van-checkbox :name="item">
              <span style="font-size: 10pt"> {{ item.Name }} </span>
              <span v-if="item.Price > 0" style="color: red">
                ({{ item.Price }})
              </span>
            </van-checkbox>
          </div>
        </div>
      </van-checkbox-group>

      <!-- <van-checkbox-group v-if="RemarkVisible" v-model="ProductRemarkOpts" direction="horizontal"
        :max="Product.RemarkRequiredCount">
        <div v-for="item in Product.ProductRemarkFree" :key="item.Id" class="product_remark">
          <van-checkbox @click="CheckProductRemark" :icon-size="17" shape="square" :name="item">
            {{ item.Name + item.PriceFormat }}</van-checkbox>
        </div>
        <div v-for="item in Product.ProductRemarkCollectFree" :key="item.Id" class="product_remark">
          <van-checkbox @click="CheckProductRemark" :icon-size="17" shape="square" :name="item">
            {{ item.Name + item.PriceFormat }}</van-checkbox>
        </div>
      </van-checkbox-group> -->

      <div
        style="
          width: 100%;
          display: flex;
          justify-content: center;
          margin-top: 10px;
        "
      >
        <van-button
          v-if="RemarkVisible"
          icon="arrow-up"
          size="small"
          style="width: 120px"
          @click="RemarkVisible = false"
        >
          {{ tools.GetLanguageValue("public.app.隐藏要求") }}
        </van-button>
        <van-button
          v-if="!RemarkVisible"
          icon="arrow-down"
          size="small"
          style="width: 120px"
          @click="RemarkVisible = true"
        >
          {{ tools.GetLanguageValue("public.app.显示要求") }}
        </van-button>
      </div>

      <div
        style="padding: 5px 5px 20px 5px"
        v-html="ProductItem.Description"
      ></div>

      <!-- 过敏原 -->
      <div
        style="
          background-color: #fff;
          border-radius: 5px;
          width: calc(100% - 8px);
          margin: 0 auto;
          margin-top: 10px;
        "
        v-if="Product.Allergens.length > 0"
      >
        <div
          style="
            height: 40px;
            border-bottom: 1px solid #e6e6e6;
            line-height: 40px;
            font-size: 18px;
          "
        >
          <span style="margin-left: 12px">
            {{ tools.GetLanguageValue("public.app.过敏原") }}
          </span>
        </div>
        <div
          style="
            width: calc(100% - 20px);
            display: flex;
            justify-content: space-between;
            flex-wrap: wrap;
            align-items: center;
            margin: 0 auto;
            gap: 15px 5px;
            margin-top: 10px;
          "
        >
          <div
            v-for="item in Product.Allergens"
            :key="item"
            style="width: 49%; display: flex; align-items: center"
          >
            <van-image
              lazy-load
              class="item_picture"
              fit="contain"
              style="width: 26px"
              :src="item.CompleteImages"
            />

            {{ item.Name }}
          </div>
        </div>
      </div>
    </div>
  </van-action-sheet>
</template>
<script>
import axios from "../../commons/AxiosMethod.js";
import tools from "../../commons/tools.js";
import AttributeGroupModule from "../../components/AttributeGroupModule.vue";
import { showToast, showConfirmDialog } from "vant";
export default {
  data() {
    return {
      index: 0,
      clientWidth: document.body.clientWidth,
      clientHeight: document.documentElement.clientHeight,
      Product: {
        Count: 1,
        AddIsConfirm: false,
      }, // 商品
      tools: tools,
      AttributeShow: false, // 显示属性面板
      ProductAttributeOpt: [], // 选中属性
      ProductRemarkOpts: [], // 选中备注
      _CollectionId: "", // 合集ID
      _OrderId: "", // 订单ID
      _CartId: "", // 购物车ID
      TableId: "", //
      imageHeigth: 100,
      UpdateProduct: () => {},
      RemarkVisible: false,
    };
  },
  name: "App",
  props: {
    ProductItem: {},
    CollectionId: "", // 合集ID
    OrderId: "", // 订单ID
    CartId: "", // 购物车ID
    update: null,
    ImageHeigth: 100,
  },
  mounted() {
    this.UpdateProduct = this.update;
    this._CollectionId = this.CollectionId;
    this._OrderId = this.OrderId;
    this._CartId = this.CartId;

    this.Product = this.ProductItem;

    this.ProductRemarkOpts = [];
    this.TableId = localStorage.getItem("Cache-TableId");

    this.imageHeigth = this.ImageHeigth;
    if (this.imageHeigth < 100) {
      this.imageHeigth = 100;
    }

    if (this.Product.IsRemarkRequired) {
      this.RemarkVisible = true;
    }
  },
  components: {
    AttributeGroupModule,
  },
  methods: {
    beforeChange(value) {
      return false;
    },
    // 查看详细页面
    LookProductDetail(product) {
      const param = { Id: this.ProductItem.Id };
      axios.apiMethod(
        "/Shopping/Product/GetProduct",
        "get",
        param,
        (result) => {
          this.Product = result.Data;

          this.AttributeShow = true;
        }
      );
    },
    CheckProductRemark() {
      if (!this.Product.IsRemarkRequired) return;
      if (this.ProductRemarkOpts.length >= this.Product.RemarkRequiredCount) {
        showToast(
          tools.GetLanguageValue("public.app.最多可以选择") +
            this.Product.RemarkRequiredCount +
            tools.GetLanguageValue("public.app.个")
        );
      }
    },

    AddConfirm() {
      showConfirmDialog({
        title: tools.GetLanguageValue("public.app.此商品将要收费"),
        message: tools.GetLanguageValue("public.app.确定要添加吗"),
        confirmButtonText: tools.GetLanguageValue("public.app.确认"),
        cancelButtonText: tools.GetLanguageValue("public.app.取消"),
      })
        .then(() => {
          this.GetProduct();
        })
        .catch(() => {
          // on cancel
        });
    },

    // 获取商品
    GetProduct() {
      const param = { Id: this.ProductItem.Id };

      axios.apiMethod(
        "/Shopping/Product/GetProduct",
        "get",
        param,
        (result) => {
          this.Product = result.Data;
          if (result.Data.IsRemarkRequired || result.Data.IsRequired) {
            this.AttributeShow = true;
            return;
          }
          {
            var addcartDetailed = localStorage.getItem("addcartDetailed");

            if (addcartDetailed != "yes") {
              this.AddShoppingCart();
              return;
            } else {
              this.AttributeShow = true;
            }
          }
        }
      );
    },
    // 添加集合小项
    AddShoppingCart() {
      const param = {
        CollectionId: this._CollectionId, // 合集ID (合集本身ID)
        ShoppingCartId: this._CartId, // 购物车ID (合集购物车ID)
        ProductId: this.Product.Id, // 小项ID
        Remarks: this.Product.Remarks,
        ProductRemarkItemsOpt: this.ProductRemarkOpts,
        AttributesOpt: this.Product.Groups,
        TableId: this.TableId,
        Count: 1,
      };

      if (this.Product.IsRemarkRequired || this.Product.IsRequired) {
        // 如果要求必选

        if (this.ProductRemarkOpts.length <= 0) {
          showToast(tools.GetLanguageValue("public.app.请选择要求"));
          return;
        }
      }

      axios.apiMethod(
        "/Store/StoreOrder/AutoAddCollectionItem",
        "post",
        param,
        (result) => {
          if (result.Data.IsSuccess) {
            this.ProductRemarkOpts = [];
            this.AttributeShow = false;

            this.ProductItem.Count += 1;
            this.UpdateProduct();

            this.$store.state.Carts.NotPlaceCount += 1;
            this.$store.commit({
              type: "updateCart",
              carts: this.$store.state.Carts,
            });

            if (result.Data.MsgType == 100) {
              showToast({
                duration: 5000,
                message: result.Data.Msg,
              });
            }
          } else {
            showToast({
              className: "toast_font",
              overlayClass: "toast_overlay",
              wordBreak: "keep-all",
              closeOnClick: true,
              closeOnClickOverlay: true,
              overlay: true,
              duration: 5000,
              message: result.Data.Msg,
            });
          }
        }
      );
    },

    // 减少商品
    MinusCartItem() {
      if (this.ProductItem.Count < 1) {
        return;
      }
      axios.apiMethod(
        "/shoppings/Collection/MinusCollectionCartItem",
        "get",
        {
          productId: this.Product.Id,
          collectionId: this._CartId,
          tableId: this.TableId,
        },
        (result) => {
          if (result.Data.IsSuccess) {
            // this.ProductItem.Count = result.Data.Model.Count;

            this.UpdateProduct();

            this.$store.state.Carts.NotPlaceCount -= 1;
            this.$store.commit({
              type: "updateCart",
              carts: this.$store.state.Carts,
            });
          }
          showToast(result.Data.Msg);
        },
        (e) => {}
      );
    },
  },
};
</script>

<style lang="scss" scoped>
.product_remark {
  padding: 5px;
  font-size: 9pt;
  border: 1px solid #eee;
  margin: 3px;
  border-radius: 5px;
}

.item_content {
  background-color: #fff;
  border-radius: 8px;
  padding: 1px 15px;

  .pricture_name {
    margin-top: 5px;
    color: #333;
    font-size: 13pt;
    width: 80%;
    height: 20px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    text-align: left;
    font-family: Avenir, Helvetica, Arial, sans-serif;
    font-weight: 500;
  }

  .item_content_area {
    margin: 0 auto;
    margin-top: 10px;
    width: calc(100% - 20px);

    border-radius: 5px;
    display: flex;
    border-bottom: 1px dashed rgb(166, 163, 163);

    .item_picture {
      background-color: #fff;
      width: 125px;
      height: 80px;
    }

    .item_price_cart {
      margin: 0 auto;
      font-size: 9pt;
      width: 95%;
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      position: relative;

      .description {
        width: 100%;
        padding: 0px 5px;
        overflow: hidden;
        height: 46px;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 3;
        overflow: hidden;
        font-size: 12px;
        text-overflow: ellipsis;
        white-space: normal;
      }

      .item_price_cart_bottom {
        position: absolute;
        height: 40px;
        bottom: 0px;
        right: 0px;
        line-height: 40px;
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;

        .item_price {
          width: 100px;
          line-height: 20px;
          color: #333;
          font-family: "Titillium Web", Arial, sans-serif;
          font-size: 13pt;
          text-align: c;
        }
      }
    }
  }

  .item_content_chengfen {
    height: 20px;
    display: flex;

    .items {
      width: 20px;
      height: 20px;
      border: 1px solid #333;
      margin-left: 5px;
      text-align: center;
    }
  }
}

.stepper_content {
  display: flex;
  width: 100px;
  justify-content: end;

  .count_input {
    width: 28px;
    height: 22px;
    border: 0px;
    text-align: center;
    background-color: rgb(248, 248, 248);
    font-size: 12pt;
  }

  .count_plus {
    border: 1px solid #333;
    border-radius: 12px;
    height: 22px;
    width: 22px;
    padding: 0px;
    text-align: center;
    line-height: 22px;
  }
}

.item_bottom {
  width: 100%;
  display: flex;
  justify-content: space-between;
  padding: 5px 0px;
}
</style>
